import { useApp } from '@boozt/app/context';
import { renderReactLegacy } from '@boozt/helper';
import { HeaderTopStandalone } from '@common/Navigation/containers/HeaderTop';

type Stores = Array<{
    url: string;
}>;

type PromobarPropsType = {
    headerTopStandalone: {
        stores: Stores;
    };
};

export default function Promobar() {
    const { props, context } = useApp();
    const { headerTopStandalone } = props as PromobarPropsType;

    headerTopStandalone.stores = headerTopStandalone.stores.reduce<Stores>((prev, curr) => {
        curr.url = `/?${curr.url.split('?')?.[1]}`;

        return [
            ...prev,
            curr,
        ];
    }, []);

    return (
        <>
            {renderReactLegacy(HeaderTopStandalone, context, headerTopStandalone)}
        </>
    );
}
